var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5974 22.0002H18.6479V21.0001C18.6479 20.45 19.0451 20 19.5307 20H40.7144C41.1999 20 41.5971 20.45 41.5971 21.0001L41.5974 22.0002Z",
    fill: "#F3DF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9494 18.0002H21.2959V17.0001C21.2959 16.45 21.6931 16 22.1787 16H38.0664C38.552 16 38.9491 16.45 38.9491 17.0001L38.9494 18.0002Z",
    fill: "#F3DF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3623 24H16.8828C16.3972 24 16 24.45 16 25.0001V42.9998C16 43.5499 16.3972 43.9999 16.8828 43.9999H43.3623C43.8479 43.9999 44.2451 43.5499 44.2451 42.9998V25.0001C44.2451 24.45 43.8479 24 43.3623 24ZM32.8287 34.2487L27.4155 37.7519C27.2054 37.8891 27.0331 37.775 27.0331 37.5001V30.5001C27.0331 30.2252 27.2054 30.111 27.4158 30.2486L32.829 33.7518C33.0392 33.8891 33.0392 34.1111 32.8287 34.2487Z",
    fill: "#F3DF00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1533,
    y: 28.6641,
    width: 15.6855,
    height: 10.9284,
    fill: "#F3DF00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscription-icon.b4346192a41abc65fdd3fb30a957a901.svg";
export { ForwardRef as ReactComponent };